import useCookies from '@/hooks/useCookies';
import { http } from '@/utils/http';
import { useEffect } from 'react';

export const useUserMigration = () => {
  const [{ login_token }] = useCookies();

  useEffect(() => {
    if (login_token) {
      http.post('/api/user-migration');
    }
  }, [login_token]);
};
